export const CARD_SHAPES = {
  CIRCLE: 'circle',
  SQUARE: 'square',
  STAR: 'star',
  TRIANGLE: 'triangle',
  CROSS: 'cross',
};

export const CARD_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

export const SPECIAL_CARDS = {
  WHOT: { number: 20, shape: CARD_SHAPES.STAR },
  PICK_TWO: 2,
  PICK_THREE: 5,
  GENERAL_MARKET: 14,
  SUSPENSION: 8,
  HOLD_ON: 1,
};

export const GAME_STATES = {
  WAITING: 'waiting',
  IN_PROGRESS: 'in_progress',
  FINISHED: 'finished',
};